var map = {
	"./close-btn.webp": 1931,
	"./icon-caution.webp": 1932,
	"./icon-checked.webp": 1933,
	"./icon-contact-us.webp": 1934,
	"./icon-email.webp": 1935,
	"./icon-eye-close.webp": 1936,
	"./icon-eye-open.webp": 1937,
	"./icon-forget-phone.webp": 1938,
	"./icon-forget-whatsapp.webp": 1939,
	"./icon-google.webp": 1940,
	"./icon-login-email.webp": 1941,
	"./icon-password.webp": 1942,
	"./icon-robot-select.webp": 1943,
	"./icon-robot-unselect.webp": 1944,
	"./icon-telegram.webp": 1945,
	"./icon-user.webp": 1946,
	"./login-bg.webp": 1947,
	"./reglogin-bg-cn.webp": 1948,
	"./reglogin-bg-id.webp": 1949,
	"./reglogin-bg-ms.webp": 1950,
	"./reglogin-bg.webp": 1951,
	"./reglogin-m-bg-cn.webp": 1952,
	"./reglogin-m-bg-id.webp": 1953,
	"./reglogin-m-bg-ms.webp": 1954,
	"./reglogin-m-bg.webp": 1955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;